// Reconstructed from production code; original paths and local names were not available.
import { Link } from "react-router-dom";
import { MEDIA_BASE_URL } from "../services/config.js";
import React from "react";
import * as jsxRuntime from "react/jsx-runtime";
import { useCart } from "../context/CartContext.jsx";
import { useLanguage } from "../context/LanguageContext.jsx";
function ProductCartIcon() {
  return (
    <svg viewBox={"0 0 24 24"} fill={"none"} aria-hidden={"true"}>
      <path
        d={"M3 4h2.2l2.1 10.1a2 2 0 0 0 2 1.6h8.4a2 2 0 0 0 2-1.6l1.1-5.6H6.3"}
      />
      <circle cx={"9"} cy={"20"} r={"1.4"} />
      <circle cx={"17.5"} cy={"20"} r={"1.4"} />
      <path d={"M17.5 4.5v5M15 7h5"} />
    </svg>
  );
}
function ProductCard({ product: product, priority: i = false }) {
  const { language: language, t: t, tProd: tProd, tText } = useLanguage(),
    { addToCart: addToCart } = useCart(),
    [m, y] = React.useState(false),
    [g, p] = React.useState(false),
    [b, x] = React.useState(false),
    O = Number(product.price || 0),
    H = Number(product.sale_price || 0),
    E = Number.isFinite(H) && H > 0 && H < O,
    M = E ? Math.round(((O - H) / O) * 100) : 0,
    N =
      product.image_url ||
      product.main_image_url ||
      (product.images && product.images[0]?.image_url),
    T = N ? (N.startsWith("http") ? N : `${MEDIA_BASE_URL}${N}`) : null,
    Y = tProd(product.short_description || product.description || "", product, product.short_description ? "short_description" : "description"),
    $ = Y.length > 75 ? `${Y.slice(0, 75)}...` : Y,
    I = product.subcategory_name || product.category_name || "",
    K = product.public_slug || product.id,
    J = Array.isArray(product.variants) ? product.variants : [],
    Q = tProd(product.name, product, "name") || (language === "ar" ? "منتج" : tText("Product")),
    W = J.slice(0, 3),
    te = !!product.youtube_url || J.some((he) => !!he.youtube_url),
    oe = async (he) => {
      if (
        (he.preventDefault(),
        he.stopPropagation(),
        !(product.out_of_stock || b))
      )
        try {
          x(true);
          await addToCart(product.id);
        } catch (be) {
          console.error("Unable to add product to cart", be);
        } finally {
          x(false);
        }
    };
  return (
    <article className={"product-card"}>
      <Link
        to={`/products/${K}`}
        className={"product-card-main-link"}
        aria-label={
          language === "ar" ? `عرض تفاصيل ${Q}` : `View details for ${Q}`
        }
      >
        <div className={"product-media"}>
          {T && !g ? (
            <jsxRuntime.Fragment>
              {!m && (
                <span
                  className={"product-media-loading"}
                  aria-hidden={"true"}
                />
              )}
              <img
                src={T}
                alt={Q}
                className={`product-img${m ? " is-loaded" : ""}`}
                loading={i ? "eager" : "lazy"}
                fetchPriority={i ? "high" : "low"}
                decoding={"async"}
                sizes={
                  "(max-width: 359px) 92vw, (max-width: 720px) 46vw, (max-width: 1200px) 30vw, 280px"
                }
                onLoad={() => y(true)}
                onError={() => p(true)}
              />
            </jsxRuntime.Fragment>
          ) : (
            <div className={"product-img product-img-placeholder"}>
              {tProd(product.name, product, "name")?.slice(0, 2) || "P"}
            </div>
          )}
          {product.out_of_stock ? (
            <span
              className={"product-sale-flag"}
              style={{
                background: "var(--danger, #ef4444)",
                color: "#fff",
              }}
            >
              {language === "ar" ? "نفاد المخزون" : "Out of Stock"}
            </span>
          ) : E ? (
            <span className={"product-sale-flag"}>
              {language === "ar" ? "تخفيض" : "Sale"}
            </span>
          ) : null}
          {te && <span className={"product-video-flag"}>{tText("Video")}</span>}
          <span className={"product-view-chip"}>
            {language === "ar" ? "عرض التفاصيل" : "View Details"}
          </span>
        </div>
        <div className={"product-body"}>
          <div className={"product-card-meta"}>
            {I && <span>{tProd(I)}</span>}
            {E && (
              <strong>
                {"-"}
                {M}
                {"%"}
              </strong>
            )}
          </div>
          <h3>{Q}</h3>
          {E ? (
            <div className={"product-price-row"}>
              <span className={"product-price-sale"}>{H.toFixed(3)}</span>
              <span className={"product-price-old"}>{O.toFixed(3)}</span>
              <span className={"product-price-badge"}>
                {"-"}
                {M}
                {"%"}
              </span>
            </div>
          ) : (
            <p className={"product-price"}>{O.toFixed(3)}</p>
          )}
          {W.length > 0 && (
            <div className={"product-card-variants"}>
              <span className={"product-card-variants-label"}>
                {language === "ar" ? "الأحجام المتاحة" : "Available Sizes"}
              </span>
              <div className={"product-card-variant-list"}>
                {W.map((he) => (
                  <span className={"product-card-variant-chip"} key={he.id}>
                    {tProd(he.name, he, "name")}
                  </span>
                ))}
                {J.length > W.length && (
                  <span className={"product-card-variant-more"}>
                    {"+"}
                    {J.length - W.length}
                  </span>
                )}
              </div>
            </div>
          )}
          {$ && <p className={"product-description"}>{$}</p>}
        </div>
      </Link>
      <div className={"product-card-actions"}>
        <Link
          to={`/products/${K}`}
          className={"btn btn-outline product-card-action"}
        >
          {language === "ar" ? "عرض المنتج" : "View Product"}
          <span aria-hidden={"true"}>{language === "ar" ? "←" : "→"}</span>
        </Link>
        <button
          type={"button"}
          className={"product-card-quick-add"}
          onClick={oe}
          disabled={!!product.out_of_stock || b}
          aria-label={
            product.out_of_stock
              ? language === "ar"
                ? "المنتج غير متوفر"
                : "Product is out of stock"
              : `${t("addToCart")}: ${Q}`
          }
          title={product.out_of_stock ? void 0 : t("addToCart")}
        >
          <ProductCartIcon />
        </button>
      </div>
    </article>
  );
}
export { ProductCartIcon, ProductCard };
